import { Button as Btn } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  color?:
    | 'red'
    | 'blue'
    | 'yellow'
    | 'green'
    | 'purple'
    | 'orange'
    | 'gray'
    | 'white'
    | 'black'
    | 'teal'
    | 'lime'
    | 'indigo'
    | 'fuchsia'
    | 'pink'
    | 'rose';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

function Button({
  children,
  className,
  color = 'blue',
  size = 'md',
  ...other
}: ButtonProps) {
  return (
    <Btn
      className={twMerge([
        'data-[disabled]:bg-primary-disabled rounded bg-primary text-white disabled:cursor-not-allowed disabled:opacity-70 data-[active]:bg-primary-active data-[hover]:bg-primary-hover',
        size === 'sm' && 'px-2 py-1 text-sm',
        size === 'md' && 'px-4 py-2 text-sm',
        size === 'lg' && 'px-6 py-3 text-sm',
        color === 'red' &&
          'bg-red-500 hover:bg-red-400 data-[hover]:bg-red-400',
        color === 'blue' &&
          'bg-blue-500 hover:bg-blue-400 data-[hover]:bg-blue-400',
        color === 'yellow' &&
          'bg-yellow-500 hover:bg-yellow-400 data-[hover]:bg-yellow-400',
        color === 'green' &&
          'bg-green-500 hover:bg-green-400 data-[hover]:bg-green-400',
        color === 'purple' &&
          'bg-purple-500 hover:bg-purple-400 data-[hover]:bg-purple-400',
        color === 'orange' &&
          'bg-orange-500 hover:bg-orange-400 data-[hover]:bg-orange-400',
        color === 'gray' &&
          'bg-gray-500 hover:bg-gray-400 data-[hover]:bg-gray-400',
        color === 'white' &&
          'bg-white hover:bg-gray-100 data-[hover]:bg-gray-100',
        color === 'black' &&
          'bg-black hover:bg-gray-800 data-[hover]:bg-gray-800',
        color === 'teal' &&
          'bg-teal-500 hover:bg-teal-400 data-[hover]:bg-teal-400',
        color === 'lime' &&
          'bg-lime-500 hover:bg-lime-400 data-[hover]:bg-lime-400',
        color === 'indigo' &&
          'bg-indigo-500 hover:bg-indigo-400 data-[hover]:bg-indigo-400',
        color === 'fuchsia' &&
          'bg-fuchsia-500 hover:bg-fuchsia-400 data-[hover]:bg-fuchsia-400',
        color === 'pink' &&
          'bg-pink-500 hover:bg-pink-400 data-[hover]:bg-pink-400',
        color === 'rose' &&
          'bg-rose-500 hover:bg-rose-400 data-[hover]:bg-rose-400',
        className,
      ])}
      {...other}
    >
      {children}
    </Btn>
  );
}

export default Button;
